import { ColorKey } from 'components/ColorKey'
import { TimeStamp } from 'components/TimeStamp'
import { ReactNode } from 'react'
import styled from 'styled-components'

export const ChartFrame = ({
  title,
  lead,
  source,
  footnote,
  children,
  timestamp,
  colorKeyEntries,
  colorKeyIsRange,
  colorMode = 'light',
  lang,
}: {
  title?: string
  lead?: string | ReactNode
  footnote?: string | ReactNode
  source?: string
  children?: ReactNode
  timestamp?: ReactNode
  colorKeyEntries?: { label: string; color: string }[]
  colorKeyIsRange?: boolean
  colorMode?: 'dark' | 'light' | undefined
  lang: 'de' | 'fr'
}) => {
  return (
    <ChartFrameRoot className='CHARTFRAME'>
      {timestamp && (
        <>
          <TimeStamp lang={lang}>{timestamp}</TimeStamp>
        </>
      )}
      {title && <Title>{title}</Title>}
      {lead && (
        <Lead
          colorMode={colorMode}
          style={{
            marginBottom: !colorKeyEntries ? '30px' : undefined,
          }}
        >
          {lead}
        </Lead>
      )}{' '}
      <Spacer />
      {colorKeyEntries && (
        <ColorKey entries={colorKeyEntries} fromto={colorKeyIsRange} />
      )}
      {children}
      {footnote && <Footnote>{footnote}</Footnote>}
      {source && <Source>{source}</Source>}
    </ChartFrameRoot>
  )
}

const ChartFrameRoot = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 30px;
  padding-bottom: 60px;
  max-width: calc(100vw - 40px);
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.4em;
  padding-top: 10px;
  margin-bottom: 8px;
`
const Lead = styled.div<{ colorMode?: 'dark' | 'light' | undefined }>`
  font-size: 14px;
  margin-top: 5px;
  line-height: 1.6em;
  max-width: 600px;
  color: var(--chart-lead-color);
`
const Source = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: var(--gray-3);
  line-height: 1.3em;
`
const Footnote = styled.div`
  margin-top: 10px;
  font-size: 12px;
  color: var(--gray-3);
  line-height: 1.3em;
`
const Spacer = styled.div`
  height: 10px;
`
